export const cadastreFields = () => [
  {
    name: 'registry_number',
    required: true,
    type: 'string',
    size: 'ms-sm12',
  },
  {
    name: 'city',
    required: true,
    type: 'string',
    size: 'ms-sm6',
  },
  {
    name: 'volume',
    required: true,
    type: 'string',
    size: 'ms-sm6',
  },
  {
    name: 'book',
    required: true,
    type: 'string',
    size: 'ms-sm6',
  },
  {
    name: 'folio',
    required: true,
    type: 'string',
    size: 'ms-sm6',
  },
  {
    name: 'property_number',
    required: true,
    type: 'string',
    size: 'ms-sm12',
  },
];

export const cadastreProps = () => {
  const result = {};

  cadastreFields(null).forEach((field) => {
    result[field.name] = field.type === 'string' ? '' : 0;
  });

  return result;
};



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_es/cadastreFields/index.js